module.exports = __webpack_public_path__ + "media/images/talent/lp/ambassador/check-960f9aeaf97f828f01a211b14c9ed2fe.svg";